import { SvgIcon, SvgIconProps } from "@mui/material";

export const C2PAIconTextToImage = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 17 18" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M15.5267 8.5V15.5267H8.5C4.61833 15.5267 1.47333 12.3817 1.47333 8.5C1.47333 4.61833 4.61833 1.47333 8.5 1.47333C12.3817 1.47333 15.5267 4.61833 15.5267 8.5ZM0 8.5C0 3.81083 3.81083 0 8.5 0C13.1892 0 17 3.81083 17 8.5V17H8.5C3.81083 17 0 13.1892 0 8.5ZM3.38583 8.84C3.38583 10.5896 4.56875 12.07 6.44583 12.07C7.99 12.07 9.03833 11.05 9.29333 9.71833H7.76333C7.565 10.3275 7.07625 10.7029 6.44583 10.7029C5.49667 10.7029 4.87333 9.95208 4.87333 8.84C4.87333 7.72792 5.49667 6.97708 6.44583 6.97708C7.055 6.97708 7.54375 7.32417 7.74917 7.905H9.28625C9.01708 6.60167 7.97583 5.61 6.44583 5.61C4.56167 5.61 3.38583 7.09042 3.38583 8.84ZM11.3404 5.78H9.89542V11.9071H11.3971V8.7125C11.3971 8.11042 11.5671 7.72083 11.8575 7.47292C12.1125 7.24625 12.4454 7.12583 12.9908 7.12583H13.3733V5.70917H12.9979C12.2046 5.70917 11.6804 5.99958 11.3404 6.43875V5.77292V5.78Z"
					fill="#141414"
				/>
			</svg>
		</SvgIcon>
	);
};
